import styled from 'styled-components'
import Button from 'components/Button'
import FontAwesome from 'react-fontawesome'

const ToggleButton = styled(Button)`
  background: none;
  color: var(--white);
  border-color: var(--white);
  width: 34px;
  height: 34px;
  padding: 0;
  font-size: 16px;
  margin-left: 10px;

  &:hover {
    background: var(--white);
    color: var(--main-color);
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }
`

const Toggle = ({ handleClick }) => (
  <ToggleButton onClick={handleClick}>
    <FontAwesome name="sticky-note" />
  </ToggleButton>
)

export default Toggle
